import React from "react";
import {
  ChecklistItemCard,
  ChecklistItemCardProps,
} from "./ChecklistItemCard";

export type SentBackChecklistItemCardProps = Omit<
  ChecklistItemCardProps,
  "variant"
>;

export const SentBackChecklistItemCard: React.FC<
  SentBackChecklistItemCardProps
> = (props) => {
  return <ChecklistItemCard {...props} variant="sentBack" />;
};
